import { ReactElement, useEffect, useState } from 'react';
import styled, { ColorsTypes } from 'styled-components';

import { createUrl, request } from 'app/utils';
import { AxiosResponse } from 'axios';
import { Button, Logo } from 'components';
import { Flex } from 'components/flex';
import Typography from 'components/typography';
import { AccountApiResponse } from 'features/account';
import { useSchool } from 'features/school';
import { Link, useNavigate } from 'react-router-dom';

interface WrapperProps {
  wrapperAlpha: boolean | number;
  wrapperBg: ColorsTypes;
}

const Wrapper = styled(Flex)<WrapperProps>`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  min-height: 50px;
  z-index: 1000;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: ${({ theme, wrapperBg }) => theme.colors[wrapperBg]};
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    opacity: ${({ wrapperAlpha }) => `${wrapperAlpha}`};
  }
`;

const NotFound = (): ReactElement => {
  // const { loginEmail } = useAuth();
  const navigate = useNavigate();
  const { apiGatewayUrl } = useSchool();
  const [loginEmail, setLoginEmail] = useState('');

  const fetch = async () => {
    await Promise.all([
      request({
        url: `/api/v1/School/MyAccount`,
        method: 'get',
        baseURL: apiGatewayUrl,
        data: {
          productSlug: null,
          specialOnly: null,
          itensPerQuery: 8,
        },
      }).then(({ data }: AxiosResponse<AccountApiResponse>) => {
        setLoginEmail(data.accountLogin);
      }),
    ]);
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <Wrapper borderRadius={0} position={'absolute'} justifyContent="center" wrapperBg="dark_150" wrapperAlpha={1}>
      <Flex flex={1} flexGrow={0} flexDirection="column" zIndex={150} alignItems="center" justifyContent="space-between">
        <Flex flexGrow={0} justifyContent="center" pt={50}>
          <Flex flexGrow={0} mb={10}>
            <Logo />
          </Flex>
          <Flex width={480}>
            <Typography type="type5" color="white" mb={5} textAlign="center">
              O conteúdo não foi encontrado ou seu usuário não tem acesso ao conteúdo.
            </Typography>
          </Flex>
          <Button
            outline
            bg="primary_400"
            size="small"
            color="white"
            colorHover="white"
            width={250}
            onClick={() => {
              navigate(createUrl('dashboard'));
            }}
            style={{ textTransform: 'inherit', fontWeight: 'normal' }}
          >
            VOLTAR PARA A PÁGINA INICIAL
          </Button>
        </Flex>
        <Flex flexGrow={0} justifyContent="center" width={480}>
          <Flex flexGrow={0} mb={2}>
            <Typography type="type3" color="white" textAlign="center">
              Você esta acessando como{' '}
              <Typography type="type3" color="primary_400" textAlign="center">
                {loginEmail}
              </Typography>
            </Typography>
          </Flex>
          <Typography type="type2" color="white" mb={5} textAlign="center">
            não é você{' '}
            <Link to={createUrl('logout')}>
              {' '}
              <Typography type="type2" color="primary_400">
                clique aqui
              </Typography>
            </Link>{' '}
            e faça seu login
          </Typography>
        </Flex>
      </Flex>
    </Wrapper>
  );
};

export default NotFound;
